import CreateVideoCategoryContainer from "../containers/CreateVideoCategoryContainer";

const CreateVideoCategoryPage = () => {
  return (
    <CreateVideoCategoryContainer />
  );
};

export default CreateVideoCategoryPage;
